import { QuestionStep } from './models/step/question-step.model';
import { Step } from './models/step/step.model';
import { ThankYouStep } from './models/step/thank-you-step.model';

export class StepMapper {
  public static fromDto(dto: any): Step {
    if (dto.thankYou) {
      return ThankYouStep.fromDto(dto);
    }
    if (dto.question) {
      return QuestionStep.fromDto(dto);
    }
    const step: Step = new Step();
    // Use an internal method or just map it here since Step is simple
    step.position = dto.position;
    step.totalQuestions = dto.totalQuestions;
    // feedback mapping if needed, but usually it's one of the subclasses
    return step;
  }
}
